import React, { useEffect, useRef, useState } from "react";
import Select from 'react-select';
import { Table, FormGroup, Row, Col, CardBody, Card, Container, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label } from "reactstrap";
import { Link } from 'react-router-dom';
import 'toastr/build/toastr.min.css';
import profile from "../../assets/images/Bastet_logo.png";
import { StoreService } from '../../services/storeService';
import { useParams } from 'react-router-dom';
import './button.scss';
// Rating Plugin
import StarRatingComponent from "react-star-rating-component";
import { addToCart } from '../../store/auth/cart/actions';
import { useDispatch, useSelector } from 'react-redux';
import ReactImageGallery from "react-image-gallery";
import "react-image-gallery/styles/scss/image-gallery.scss";
import "react-image-gallery/styles/css/image-gallery.css";
import "./ProductDetail.scss"
import * as moment from 'moment';
import toastr, { success } from 'toastr'

 
 
export default function ProductDetail(props) {
 
    var Carousel = require("react-responsive-carousel").Carousel;
 
    const myRefs = useRef([]);
    const [showReturnToChat, setShowReturnToChat] = useState(false);
    const storeService = new StoreService();
    const [products, setProducts] = useState([])
   
    const [selectedZise, setSelectedZise] = useState();
 
    const [counters, setCounters] = useState({});
    const params = useParams();
    const [modalComments, setModalComments] = useState({ show: false, comments: [] });
    const tiendasGuardadas = []
    const dispatch = useDispatch()
    const sele = useSelector(store => store.cart.countercart)
    const [zoom, setZoom] = useState(false);
    const [chatHistorial, setChatHistorial] = useState([]);


    const [addressStore, setAddressStore] = useState();
   
    const getActiveStores = async () => {
        const data = await storeService.getActive();
        if (data?.length > 0) {
            setAddressStore(data[0])
        }
    }
   
    useEffect(() => {
        if (!tiendasGuardadas || tiendasGuardadas.length === 0) {
            getActiveStores();
        }
    }, [])
   
    const sendProduct = (item, index) => {
        const count = counters[index] || 1;
        if (item.productDetailModel.cantidad >= count) {
            let productNew = {
                id: item.productDetailModel.id,
                image: item.productDetailModel.fotoPrincipal,
                name: item.productDetailModel.descripcion,
                store: item.productDetailModel.nombreTienda,
                rating: item.productDetailModel.calificacion,
                newPrice: item.productDetailModel.valorMoneda,
                price: item.productDetailModel.valor,
                idStore: item.productDetailModel.idTienda,
                counter: count,
                Referencia: item.productDetailModel.referencia,
                Iva: item.productDetailModel.iva,
                Descuento: item.productDetailModel.descuento,
                existencia: item.productDetailModel.cantidad,
            }
         
            dispatch(addToCart(productNew));
        } else {
            toastr.info('No existe en inventario la cantidad solicitada.', 'Advertencia', {
                "preventDuplicates": true
            });
        }
    }
 
   
    const formatterPeso = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
    })
   
   
    //Nueva funcion
    const fetchAllProductsAndComments = async (ids) => {
        const idArray = ids.split(',');
 
        const productPromises = idArray.map(id => storeService.getDetailProducts(id));
        const commentPromises = idArray.map(id => storeService.getCommentProduct(id));
 
        const [productsData, commentsData] = await Promise.all([
            Promise.all(productPromises),
            Promise.all(commentPromises)
        ]);

        console.log('[DEBUG] Productos cargados:', productsData);
     
        const combined = productsData.map((product, index) => {
            let imagesTmp = [];
       
            if (product.caracteristicasModel.length > 0) {
                product?.productDetailModel?.fotoPrincipal &&
                    imagesTmp.push({
                        original: product.productDetailModel?.fotoPrincipal,
                        thumbnail: product.caracteristicasModel[product.caracteristicasModel.length - 1]?.valor
                    })
            } else {
                product?.productDetailModel?.fotoPrincipal &&
                    imagesTmp.push({
                        original: product.productDetailModel?.fotoPrincipal,
                        thumbnail: product.caracteristicasModel[1]?.valor
                    })
            }
         
            return {
                product,
                comments: commentsData[index],
                images: imagesTmp
            }
        });
     
        setProducts(combined);
        return combined;
    };
 
 
    const initializeCounters = (productsData) => {
        const initialCounters = {};
        productsData.forEach((_, index) => {
            initialCounters[index] = 1;
        });
        setCounters(initialCounters);
    };
 
    useEffect(() => {
        if (params.id) {
            fetchAllProductsAndComments(params.id).then((productsData) => {
                initializeCounters(productsData);
            });
        }
    }, [params.id]);
 
 
   
 
    useEffect(() => {
      myRefs.current = new Array(products.length).fill().map((_, i) => myRefs.current[i] || React.createRef());
    }, [products]);
 
 
    useEffect(() => {
        if (params.id) {
            fetchAllProductsAndComments(params.id);
        }
    }, [params.id]);
   

    useEffect(() => {
  const historial = localStorage.getItem('chatHistorial');
  if (historial) {
    try {
      const mensajes = JSON.parse(historial);
      setChatHistorial(mensajes);
      console.log('[DEBUG] Historial del chat recuperado:', mensajes);
    } catch (e) {
      console.error('Error al parsear el historial del chat:', e);
    }
  }
}, []);

    useEffect(() => {
      const sessionActive = localStorage.getItem('chatSessionActive');
      const alreadyShown = sessionStorage.getItem('returnToChatShown');

      if (sessionActive === 'true' && !alreadyShown) {
        setShowReturnToChat(true);

        //Marcar que ya se mostró para esta sesión
        sessionStorage.setItem('returnToChatShown', 'true');
        
      }
    }, []);


    const handleGoToChat = () => {
      setShowReturnToChat(false);
      //eliminar el estado para futuras visitas
      // localStorage.removeItem('chatSessionActive');
    };

    const [fullScreen, setFullScreen] = useState(false);
   
    const galleryProps = (index) => ({
      showBullets: true,
      thumbnailPosition: "left",
      showPlayButton: false,
      onClick: () => {
        const ref = myRefs.current[index];
        if (ref?.current) {
          if (fullScreen) {
            ref.current.exitFullScreen();
            setFullScreen(false);
          } else {
            ref.current.fullScreen();
            setFullScreen(true);
          }
        }
      }
    });
 
    const getValueSelect = (e) => {
        let data = e.target.value
        setSelectedZise(data)
    }
 
    return (
        <React.Fragment>
          <div
            className="account-pages my-5 pt-sm-5"
            style={{ backgroundColor: '#f8f9f9', color: '#FDF7EC', minHeight: '100vh' }}
          >
            <div style={{ maxWidth: '1140px', margin: '0 auto' }}>
              <Container style={{ backgroundColor: '#f8f9f9', borderRadius: '10px', padding: '2rem' }}>
                <div className="scroll-invisible" style={{ maxHeight: '80vh' }}>
                  {products.map(({ product, comments, images }, index) => (
                    <div key={index} className="product-card">
                      <Row className="justify-content-left">
                      <Col md={6} lg={6} xl={5}>
                        <div className="d-flex flex-column align-items-start pt-4">
                            {/* Detalles del producto */}
                            <Row className="d-flex justify-content-left pb-3">
                            <label className="control-label m-3">
                                <h3>Detalle del producto</h3>
                            </label>
                            </Row>
                            <div>
                              <ReactImageGallery
                                items={images}
                                {...galleryProps(index)}
                                ref={myRefs.current[index]}
                              />
 
                            </div>
                        </div>
                        </Col>
     
                        <Col md={6} lg={6} xl={5}>
                            <div className="text-center py-2">
                                <h3>{product.productDetailModel?.descripcion}</h3>
                                <Row className="my-2">
                                <Col md={4}>
                                    <StarRatingComponent
                                    value={product.productDetailModel?.calificacion}
                                    starCount={5}
                                    />
                                </Col>
                                {/* <Col md={4}>
                                    <h4>
                                    <strong>
                                        {formatterPeso.format(Math.round(product.productDetailModel?.valor * counter))}
                                    </strong>
                                    </h4>
                                </Col> */}
                                <Col md={4}>
                                    <span style={{ color: "#00a3e8" }}>
                                    {product.productDetailModel?.descuento}% Dto
                                    </span>
                                </Col>
                                </Row>
                                <hr />
                            </div>
 
                            <div className="p-1">
                                <h5 style={{ color: "#D4A14C" }}>Detalles del producto</h5>
                                <p style={{ color: "#00A3E8" }}>
                                {product.productDetailModel?.detalle}
                                </p>
                                <h5>
                                Marca:{" "}
                                <span style={{ color: "#00A3E8" }}>
                                    {product.productDetailModel?.marca || "No definida"}
                                </span>
                                </h5>
                            </div>
 
                            {/*<div className="p-1">
                                <h5>Garantía</h5>
                                <p style={{ color: "#00A3E8" }}>
                                {product.productDetailModel?.garantia || "Sin garantía"}
                                </p>
                            </div>*/}
 
                            <div className="p-1">
                                <h5>Información del producto</h5>
                                <p style={{ color: "#00A3E8" }}>
                                {product.productDetailModel?.descripcion}, Marca {product.productDetailModel?.marca}, referencia {product.productDetailModel?.referencia}
                                </p>
                            </div>
 
                            <div className="p-1">
                                <button
                                onClick={() => setModalComments({ show: true, comments })}
                                style={{ border: "0px", color: "#D4A14C" }}
                                >
                                Comentarios
                                </button>
                            </div>
 
                            <div className="d-flex justify-content-center my-2">
                                <button className="boton-cant" onClick={() => {
                                    setCounters(prev => ({
                                        ...prev,
                                        [index]: prev[index] > 1 ? prev[index] - 1 : 1
                                    }));
                                }}>
                                    <i className="fas fa-minus" style={{ color: "#D29D61" }}></i>
                                </button>
                                <strong className="mx-2" style={{ color: "black" }}>{counters[index] || 1}</strong>
                                <button className="boton-cant" onClick={() => {
                                    if (product.productDetailModel?.cantidad > (counters[index] || 1)) {
                                        setCounters(prev => ({
                                            ...prev,
                                            [index]: (prev[index] || 1) + 1
                                        }));
                                    } else {
                                        toastr.info('No existe en inventario la cantidad solicitada.', 'Advertencia', {
                                            "preventDuplicates": true
                                        });
                                    }
                                }}>
                                    <i className="fas fa-plus" style={{ color: "#365F3F" }}></i>
                                </button>
                            </div>
 
                            <div className="container text-center py-2 px-5" style={{ color: "rgba(215, 154, 54, 0.7)" }}>
                                <Row className="justify-content-center">
                                <Col md={6}>
                                    <button className="boton3-fanero btn-block" onClick={() => sendProduct(product, index)}>
                                        Agregar al carrito
                                    </button>
                                </Col>
                                <Col>
                                    <Link to="/cart" className="boton2-fanero btn-block">
                                    <span style={{ color: "#FFFFFF" }}>Ir al carrito</span>
                                    </Link>
                                </Col>
                                </Row>
                            </div>
                            </Col>
 
 
                      </Row>
                    </div>
                  ))}
                </div>
              </Container>
            </div>
          </div>
     
          {/* Modal de comentarios */}
          <Modal isOpen={modalComments.show}>
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="mySmallModalLabel">
                <img src={profile} alt="" className="img-fluid" style={{ height: '50px' }} />
                <label className="control-label m-3">Valoración del producto</label>
              </h5>
              <button onClick={() => setModalComments({ show: false, comments: [] })} type="button" className="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {modalComments.comments.length === 0 ? (
                <span>Aún no hay comentarios de este producto</span>
              ) : (
                modalComments.comments.map((com, key) => (
                  <div className="card" style={{ height: "auto" }} key={key}>
                    <div className="card-header">
                      <Row>
                        <Col md={8}><h6>{com.nombres}</h6></Col>
                        <Col md={4}><h6>{moment(com.fechaCalificacion).format('DD/MM/YYYY')}</h6></Col>
                      </Row>
                    </div>
                    <div className="card-body">
                      <Row className="card-text">
                        <Col><h1><span className="blue">{(com.nombres).charAt(0)}</span></h1></Col>
                        <Col><p className="card-text">{com.comentario}</p></Col>
                        <Col>
                          <StarRatingComponent value={com.calificacion1} starCount={5} />
                        </Col>
                      </Row>
                    </div>
                  </div>
                ))
              )}
            </div>
          </Modal>
     
          {/* Modal Zoom */}
          <Modal isOpen={zoom}>
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="mySmallModalLabel">
                <img src={profile} alt="" className="img-fluid" style={{ height: '50px' }} />
              </h5>
              <button onClick={() => setZoom(false)} type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
           
          </Modal>

          <div>
            {/* Contenido del producto */}

            {showReturnToChat && (
              <div className="return-to-chat-animation" onClick={handleGoToChat}>
                <img src="/images/flecha.png" alt="Flecha volver al chat" className="arrow-image" />
                <div className="text">Volver al chat</div>
              </div>

            )}
          </div>
        </React.Fragment>
      );
}